import { render, staticRenderFns } from "./PullRevenueManage.vue?vue&type=template&id=b7e5f8f8&"
import script from "./PullRevenueManage.vue?vue&type=script&lang=js&"
export * from "./PullRevenueManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports